/* eslint-disable import/prefer-default-export */
import { getAuth } from './auth';

export function isNotExpiredLogin(status, fn) {
  if (status === 401) {
    if (fn) {
      fn();
      return false;
    }
  }
  return true;
}

export function checkIsLogin(fn) {
  if (
    typeof getAuth().id === 'undefined' ||
    typeof getAuth().email === 'undefined'
  ) {
    isNotExpiredLogin(401, fn);
    // window.location.href = href;
  }
}



// WEBPACK FOOTER //
// ./src/service/userService.js